import { Star, Quote } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";
import { MAPS_URL } from "@/lib/site";

const TESTIMONIALS = [
  {
    quote:
      "I booked a PDI before taking delivery of my new vehicle. Hidden issues were found immediately. Highly recommended.",
    author: "Raghu Praneeth",
    role: "PDI Customer",
    slug: "raghu",
  },
  {
    quote:
      "Professional, honest and detailed inspection. The PDF report was extremely helpful.",
    author: "Verified Customer",
    role: "Google Review",
    slug: "verified",
  },
  {
    quote: "Saved me from buying a damaged used car.",
    author: "Used Car Buyer",
    role: "Hyderabad",
    slug: "saved",
  },
];

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="py-28 md:py-36">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <Chapter index="06" label="Testimonials" />
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-8 max-w-3xl font-heading text-4xl font-extrabold tracking-tight text-white md:text-6xl">
          Buyers who checked first,
          <span className="block text-white/40">and won.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <a
          data-testid="testimonials-google-link"
          href={MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-gold transition-colors duration-300 hover:text-gold-light"
        >
          See our reviews on Google
          <Star className="h-4 w-4 fill-gold text-gold" />
        </a>
      </Reveal>

      <div className="mt-16 grid gap-5 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.slug} delay={0.08 * i}>
            <figure
              data-testid={`testimonial-card-${t.slug}`}
              className="flex h-full flex-col rounded-3xl border border-white/10 bg-white/[0.03] p-8 transition-[transform,border-color] duration-500 hover:-translate-y-1.5 hover:border-gold/30"
            >
              <Quote className="h-7 w-7 text-gold/40" />
              <div className="mt-5 flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-gold text-gold" />
                ))}
              </div>
              <blockquote className="mt-5 flex-1 text-base leading-relaxed text-white/75">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 border-t border-white/10 pt-5">
                <span className="block font-heading text-sm font-extrabold text-white">
                  — {t.author}
                </span>
                <span className="mt-0.5 block text-xs font-semibold uppercase tracking-[0.18em] text-white/40">
                  {t.role}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
